import { render } from "./PikuTradeView.vue?vue&type=template&id=6f5589cd&scoped=true&ts=true"
import script from "./PikuTradeView.vue?vue&type=script&lang=ts"
export * from "./PikuTradeView.vue?vue&type=script&lang=ts"

import "./PikuTradeView.vue?vue&type=style&index=0&id=6f5589cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5589cd"]])

export default __exports__